<template>
  <div class="repay-div" ref="main">
    <div class="title">
      <div class="logo-div">
        <span class="name">Payment</span>
      </div>
      <span class="time">{{ new Date().toLocaleString() }}</span>
    </div>
    <div>
      <div class="tips-div"
           :class="{ nagad: orderInfo.walletType === 'Nagad', bkash: orderInfo.walletType === 'bKash' }">
        <div class="detail-content-div">
          <div class="tips-desc white">{{ $t('important_tips') }}</div>
          <div class="tips-desc" v-if="orderInfo.walletType">
            <template v-if="orderInfo.isCashOut">
              {{
                orderInfo.walletType === 'Nagad' ? $t("step_2_tips_Nagad_cashout") : $t("step_2_tips_bKash_cashout")
              }}
            </template>
            <template v-else>
              {{
                $t('step_2_tips_without_bank_1')
              }}
              <strong class="white">{{ orderInfo.walletType && orderInfo.walletType.toUpperCase() }}</strong>
              {{
                $t('step_2_tips_without_bank_2')
              }}
              <strong class="white">
                &nbsp;{{
                  $t('transfer')
                }}&nbsp;
              </strong>
              {{
                $t('step_2_tips_without_bank_3')
              }}
            </template>
            <template v-if="orderInfo.isCashOut">
              <strong class="white">&nbsp;{{ $t("cash_out") }}&nbsp;</strong>
              {{ $t("step_2_tip_3") }}
            </template>
          </div>
          <div class="tips-content">
            <div class="bankcard-div">
              <span class="bankcard-desc">{{ $t('wallet') }}</span>
              <span class="bankcard-value">
               <template v-for="bank in bankList">
                <div
                    class="bank-item"
                    :key="bank.value"
                    v-if="walletType === bank.value"
                >
                    <img class="bank-logo" :src="bank.logo">
                    <span class="red">{{ bank.label }}</span>
                </div>
              </template>
            </span>
            </div>
            <div class="bankcard-div">
              <span class="bankcard-desc">{{ $t('mobile') }}</span>
              <span class="bankcard-value blue"
                    v-clipboard:copy="orderInfo.receiveWalletNo"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError">
              {{ orderInfo.receiveWalletNo }}
              <i class="el-icon-document-copy"></i>
            </span>
            </div>
            <div class="bankcard-div">
              <span class="bankcard-desc">{{ $t('payment_amount') }}</span>
              <span class="bankcard-value green"
                    v-clipboard:copy="orderInfo.amount+''"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError">
              {{ orderInfo.amount && orderInfo.amount.toLocaleString() }}
              <i class="el-icon-document-copy"></i>
            </span>
            </div>
          </div>
        </div>
        <div class="tips-desc white">{{
            $t(orderInfo.walletType === 'Nagad' ? 'step_3_tips_Nagad' : 'step_3_tips_bKash')
          }}
        </div>
        <div class="input-div">
          <van-field type="text" :maxlength="transactionIdLength" v-model="transactionId"
                     class="input" ref="transactionId" @blur="checkTransactionId"
                     :class="{'input-warn': showTransactionWarn}"/>
        </div>
        <van-button class="pay-btn white" :class="{'yellow-background': orderInfo.walletType === 'bKash' }" block
                    @click="updateTransactionId" :loading="loading"
                    :disabled="!checkTransactionId()">
          {{ $t('submit') }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {repayService} from '@/services';
import {bankList} from '@/common/bank';
import logo from '@/assets/logo.png';
import nagadBdImg from '@/assets/Nagad_bd.png';
import nagadEnImg from '@/assets/Nagad_en.png';
import bKashBdImg from '@/assets/bKash_bd.png';
import bKashEnImg from '@/assets/bKash_en.png';
import bKashCashOutImg from '@/assets/bk_cash_out.png';
import bKashSendMoneyImg from '@/assets/bk_send_money.png';
import nagadCashOutImg from '@/assets/ng_cash_out.png';
import nagadSendMoneyImg from '@/assets/ng_send_money.png';
import payCenterLogo from '@/assets/paycenter-logo.png';

export default {
  name: 'IndexPage',
  data() {
    return {
      payCenterLogo,
      logo,
      nagadBdImg,
      nagadEnImg,
      bKashBdImg,
      bKashEnImg,
      bKashCashOutImg,
      bKashSendMoneyImg,
      nagadCashOutImg,
      nagadSendMoneyImg,
      title: process.env.DEPLOY_CONFIGS.title,
      bankList,
      loading: false,
      orderId: null,
      orderInfo: {},
      walletNo: null,
      walletType: null,
      transactionId: null,
      transactionIdLength: 10,
      firstConfirm: true,
      showWalletNoWarn: false,
      showTransactionWarn: false,
      returnUrl: null,
    }
  },
  activated() {
    this.orderId = this.$route.params.orderId;
    this.getInfo()
    this.returnUrl = this.$route.query.returnUrl;
  },
  methods: {
    cancelRepay() {
      window.location.href = this.returnUrl;
    },
    formatStep2TipsImg() {
      if (this.orderInfo.walletType === 'Nagad') {
        if (this.orderInfo.isCashOut) {
          return nagadCashOutImg;
        }
        return nagadSendMoneyImg;
      }
      if (this.orderInfo.isCashOut) {
        return bKashCashOutImg;
      }
      return bKashSendMoneyImg;
    },
    async getInfo() {
      let params = this.$jse.encrypt((JSON.stringify({'orderId': this.orderId})));
      repayService.getRepayInfo(params).then(res => {
        this.orderInfo = res;
        this.transactionIdLength = this.orderInfo.walletType === 'Nagad' ? 8 : 10
        this.walletNo = res.paymentWalletNo || res.customerWalletNo;
        this.walletType = res.walletType;
        if (!this.walletType) {
          this.walletType = res.customerWalletType;
          if (this.firstConfirm && this.walletType) {
            this.walletConfirm()
          }
        }
      });
    },
    selectBank(value) {
      this.walletType = value;
      this.walletConfirm();
    },
    async walletConfirm() {
      let params = this.$jse.encrypt((JSON.stringify({
        orderId: this.orderId,
        walletType: this.walletType,
      })));
      try {
        await repayService.paymentConfirm(params);
      } catch (e) {
        //
      }
      this.firstConfirm = false;
      await this.getInfo();
    },
    formatterBankcard(value) {
      return value.replace(/\s/g, '');
    },
    checkWalletNo() {
      let numCheck = /^01\d{9}$/;
      let passed = numCheck.test(this.walletNo);
      this.showWalletNoWarn = !passed;
      return passed;
    },
    checkTransactionId() {
      let passed = !!this.transactionId && this.transactionId.length === this.transactionIdLength;
      this.showTransactionWarn = !passed;
      return passed;
    },
    async updateTransactionId() {
      if (!this.walletType) {
        this.$toast({
          message: this.$t('wallet_type'),
        });
        let ref = this.$refs.main;
        ref.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        return;
      }
      // if (!this.checkWalletNo()) {
      //   this.$toast({
      //     message: this.$t('common_num_error'),
      //     className: 'noticeWidth'
      //   });
      //   this.$refs.walletNo.focus();
      //   return;
      // }
      if (!this.checkTransactionId()) {
        this.$toast({
          message: this.$t('invalid_transaction_id'),
        });
        this.$refs.transactionId.focus();
        return;
      }
      let params = this.$jse.encrypt((JSON.stringify({
        orderId: this.orderId,
        flowId: this.transactionId,
        paymentWallet: this.walletNo
      })));
      repayService.updateTransactionId(params).then(() => {
        this.$toast.success({
          message: this.$t('submit_success'),
        });
        if (this.returnUrl) {
          window.location.href = this.returnUrl;
        }
      });
    },
    onCopy() {
      this.$toast.success({
        message: this.$t('copy_success'),
      });
    },
    onError() {
      this.$toast.fail('copy_fail');
    },
  }
}
</script>

<style scoped lang="scss">
.repay-div {
  overflow: auto;
  background-color: #efefef;
}

.title {
  margin: 30px auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .logo-div {
    display: flex;
    align-items: center;
  }

  img {
    height: 40px;
    display: block;
    margin-right: 5px;
  }

  .name {
    color: black;
    font-size: 32px;
    font-weight: 700;
  }

  .time {
    color: #6d6868;
    padding-top: 5px;
    font-size: 18px;
  }
}

.bankcard-div {
  display: flex;
  justify-content: space-between;

  .bankcard-desc {
    font-size: 14px;
    color: black;
    height: 30px;
    line-height: 30px;
  }

  .bankcard-value {
    color: #222222;
    font-size: 16px;
    display: flex;
    align-items: center;

    i {
      margin-left: 8px;
    }

    .bank-item {
      display: flex;
      align-items: center;

      .bank-logo {
        height: 20px;
        margin-right: 5px;
      }
    }
  }
}

.tips-div {
  background: #FFFFFF;
  margin: 15px;
  border-radius: 5px;
  padding: 30px;
  border: 1px solid #EEEEEE;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.1);

  &.nagad {
    background-color: #f79324;
  }

  &.bkash {
    background-color: #e40153;
  }

  &:first-child {
    margin-top: 0;
  }

  .tips-step {
    color: #2752E7;
    font-size: 16px;
    font-weight: 700;
  }

  .tips-desc {
    color: black;
    font-size: 14px;
    padding: 8px 0;
    line-height: 1.8;
    font-weight: 500;
  }

  .tips-content {
    border-radius: 10px;
    border: 1px solid lightgrey;
    padding: 20px;
    background-color: #ffffff;
  }
}

.red {
  color: red !important;
}

.white {
  color: white !important;
}

.blue {
  color: #4248cc !important;
}

.green {
  color: #3fbb64 !important;
}

.strong {
  font-weight: 700;
}

.tips-value {
  font-size: 12px;
}

.warn {
  background-color: #FFEEEE;
  padding: 10px;
  border-radius: 5px;
  color: #666666;
}

.required {
  color: red;
  font-size: 16px;
  margin-right: 5px;
}

.tips-image-div {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
}

.tips-image {
  flex: 1;
  width: 50%;

  img {
    width: 100%;
  }
}

.input-div {
  .input {
    border: 1px solid lightgrey;
    border-radius: 5px;
    padding: 0;
    width: 100%;
    box-sizing: border-box;

    &.input-warn {
      border: 1px #ee0a2475 solid;
    }

    /deep/ input {
      border-radius: 5px;
      display: block;
      outline: 0;
      height: 35px;
      font-size: 14px;
    }
  }
}

.pay-btn {
  background-color: #fa0000;
  padding: 7px 17px;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  font-size: 15px;
  font-weight: 500;
  height: 38px;
  margin-top: 10px;
}
.yellow-background {
  background-color: #f79324 !important;
}
</style>
